import React from 'react';
import './EmptyStateComponent.scss';
import { teslaCacheX } from '../../Upshow';
import ReactPlayer from 'react-player';
import Logger from '../../Logger';
import ScreenService from '../../services/ScreenService';
import {getMakeConfig } from '../../utils/models';


class EmptyStateComponent extends React.Component {


    constructor(props) {
        super(props);
        this.resources = ScreenService.isVertical
        ? { url: 'https://cdn.upshow.tv/ui-assets/Everpass_No_Content_Vertical.mp4', poster: 'https://cdn.upshow.tv/ui-assets/Everpass_No_Content_Vertical.jpg' }
        : { url: 'https://cdn.upshow.tv/ui-assets/Everpass_No_Content_Horizontal.mp4', poster: 'https://cdn.upshow.tv/ui-assets/Everpass_No_Content_Horizontal.jpg' };

        this.url = teslaCacheX(this.resources.url);
        this.imgFallback = getMakeConfig().emptyState.imageFallback;
        const hasEPGFF = window.__UpshowState && !!window.__UpshowState.settings.features.on_screen_menu;
        
        if (ScreenService.isVertical) {
            this.xumoFallback = 'https://cdn.upshow.tv/ui-assets/Xumo_No_Content_Vertical.jpg';
        } else {
            this.xumoFallback = hasEPGFF ? 'https://cdn.upshow.tv/ui-assets/Xumo_No_Content_EPG_Screen.png' : 'https://cdn.upshow.tv/ui-assets/Xumo_No_Content_Horizontal.jpg';
        }
    }

    render() {
        return this.imgFallback ? ( 
            <div className="empty-state">
                <img src={this.xumoFallback} />
            </div> )
            : ( <div className="empty-state">
            <ReactPlayer
                width="100%" height="100%" volume={0} playing loop
                url={this.url}
                onError={(error) => Logger.warn('No Content state could not play loading media', error)}
                config={{
                    file: {
                        attributes: {
                            crossOrigin: 'anonymous',
                            poster: this.resources.poster
                        }
                    }
                }} />

        </div>);
    }
}

export default EmptyStateComponent;
